import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import router from "./router";
import { VueQueryPlugin } from "@tanstack/vue-query";
import Toast, { type ToastOptions } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { createPinia } from "pinia";
import piniaPersist from "pinia-plugin-persistedstate";
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
import vue3GoogleLogin from "vue3-google-login";

const toastOptions: ToastOptions = {
  position: "top-right",
  autoClose: 2500,
  pauseOnHover: true,
  theme: "dark",
};

const pinia = createPinia();
pinia.use(piniaPersist);

const app = createApp(App);
app.use(router);
app.use(VueQueryPlugin);
app.use(Toast, toastOptions);
app.use(VueAwesomePaginate);
app.use(pinia);
app.use(vue3GoogleLogin, {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
});

app.mount("#app");
